import { TESTDATA_MODAL } from '@enums/overlay-internal-events.enum';
import { DataGeneratorDrawer } from './data-generator-drawer';
import { MailBoxDrawer } from './email-box-drawer';
import { EnvironmentDrawer } from './environment-drawer';
import { ParameterDrawer } from './parameter-drawer';
import { PhoneNumberDrawer } from './phone-number-drawer';
import { UploadDrawer } from './upload-drawer';
import { RuntimeVariableDrawer } from './runtime-variable-drawer';

export const TEST_DATA_MAP = {
  [TESTDATA_MODAL.OPEN_RUNTIME_VARIABLE]: {
    uuid: 'runtime-variable',
    closeOnOutsideClick: false,
    component: (props) => (
      <RuntimeVariableDrawer
        appVersionId={props.appVersionId}
        context={props.context}
        isInsideRestApi={props?.isInsideRestApi}
      />
    ),
  },
  [TESTDATA_MODAL.CLOSE_RUNTIME_VARIABLE]: {
    uuid: 'runtime-variable',
    closeOnOutsideClick: false,
    component: null,
  },
  [TESTDATA_MODAL.OPEN_PHONE_NUMBER]: {
    uuid: 'phone-number',
    closeOnOutsideClick: false,
    component: (props) => (
      <PhoneNumberDrawer isInsideRestApi={props?.isInsideRestApi} />
    ),
  },
  [TESTDATA_MODAL.CLOSE_PHONE_NUMBER]: {
    uuid: 'phone-number',
    closeOnOutsideClick: false,
    component: null,
  },
  [TESTDATA_MODAL.OPEN_ENVIRONMENT]: {
    uuid: 'environment',
    closeOnOutsideClick: false,
    component: (props) => (
      <EnvironmentDrawer
        projectId={props.projectId}
        context={props.context}
        isInsideRestApi={props?.isInsideRestApi}
      />
    ),
  },
  [TESTDATA_MODAL.CLOSE_ENVIRONMENT]: {
    uuid: 'environment',
    closeOnOutsideClick: false,
    component: null,
  },
  [TESTDATA_MODAL.OPEN_MAILBOX]: {
    uuid: 'mail-box',
    closeOnOutsideClick: false,
    component: (props) => (
      <MailBoxDrawer isInsideRestApi={props?.isInsideRestApi} />
    ),
  },
  [TESTDATA_MODAL.CLOSE_MAILBOX]: {
    uuid: 'mail-box',
    closeOnOutsideClick: false,
    component: null,
  },
  [TESTDATA_MODAL.OPEN_PARAMETER]: {
    uuid: 'parameter',
    closeOnOutsideClick: false,
    component: (props) => (
      <ParameterDrawer
        tdpIds={props.tdpIds}
        testCaseId={props.testCaseId}
        profileList={props?.data || props?.profileList}
        context={props.context}
        isInsideRestApi={props?.isInsideRestApi}
        refetchTestCase={props.refetchTestCase}
      />
    ),
  },
  [TESTDATA_MODAL.CLOSE_PARAMETER]: {
    uuid: 'parameter',
    closeOnOutsideClick: false,
    component: null,
  },
  [TESTDATA_MODAL.OPEN_DATA_GENERATOR]: {
    uuid: 'data-generator',
    closeOnOutsideClick: false,
    component: (props) => (
      <DataGeneratorDrawer
        {...props}
        profileList={props?.data || props?.profileList}
      />
    ),
  },
  [TESTDATA_MODAL.CLOSE_DATA_GENERATOR]: {
    uuid: 'data-generator',
    closeOnOutsideClick: false,
    component: null,
  },
  [TESTDATA_MODAL.OPEN_UPLOAD]: {
    uuid: 'upload',
    closeOnOutsideClick: false,
    component: (props) => <UploadDrawer applicationId={props.applicationId} />,
  },
  [TESTDATA_MODAL.CLOSE_UPLOAD]: {
    uuid: 'upload',
    closeOnOutsideClick: false,
    component: null,
  },
};
